import { Heading } from "@/core/components/layout/heading";
import { useDashboardFilters } from "@/dashboard/store/useDashboardFilters";
import { useTranslation } from "react-i18next";
import { ActionExportReportInsights } from "./components/action-export-report-insights";

export const DashboardHeaderActions = () => {
  const [translate] = useTranslation(["dashboard"]);
  const { filters } = useDashboardFilters();

  return (
    <Heading
      title={translate("dashboard-title")}
      description={translate("dashboard-description")}
    >
      <div className="flex gap-2 items-center">
        <ActionExportReportInsights filters={filters} />
      </div>
    </Heading>
  );
};
